import { OffCanvasService } from '../services';

export abstract class OffCanvasChildComponent
{
    public data: any;
    protected readonly offCanvasService: OffCanvasService;
    public onOverlayClick(): boolean
    {
        return true;
    }

    public constructor(offCanvasService: OffCanvasService)
    {
        this.offCanvasService = offCanvasService;
        this.offCanvasService.notifyLoaded(this);
    }
}
